module.exports = __webpack_public_path__ + "static/media/shadow-02.219283e2.png";